var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1519_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3349 7.45449C6.02573 7.14533 6.02573 6.64407 6.3349 6.3349C6.64407 6.02573 7.14533 6.02573 7.45449 6.3349L9.50457 8.385L11.5502 6.33943C11.8593 6.03026 12.3606 6.03026 12.6697 6.33943C12.9789 6.6486 12.9789 7.14985 12.6697 7.45902L10.6241 9.50458L12.6698 11.5502C12.979 11.8594 12.979 12.3606 12.6698 12.6698C12.3606 12.979 11.8594 12.979 11.5502 12.6698L9.50457 10.6242L7.45908 12.6697C7.14991 12.9788 6.64866 12.9788 6.3395 12.6697C6.03033 12.3605 6.03033 11.8592 6.3395 11.5501L8.385 9.50458L6.3349 7.45449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2084 3.1665C18.2084 1.85483 17.1451 0.791504 15.8334 0.791504H3.16675C1.85508 0.791504 0.791748 1.85483 0.791748 3.1665V15.8332C0.791748 17.1449 1.85508 18.2082 3.16675 18.2082H15.8334C17.1451 18.2082 18.2084 17.1449 18.2084 15.8332V3.1665ZM16.6251 3.1665C16.6251 2.72928 16.2707 2.37484 15.8334 2.37484H3.16675C2.72953 2.37484 2.37508 2.72928 2.37508 3.1665V15.8332C2.37508 16.2704 2.72953 16.6248 3.16675 16.6248H15.8334C16.2707 16.6248 16.6251 16.2704 16.6251 15.8332V3.1665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1519_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.cf4481546a48d64a960de50884be8f82.svg";
export { ForwardRef as ReactComponent };